
import UserLayout from '../../layouts/UserLayout'
import {
    Box, OrderedList, ListItem, Heading,
} from "@chakra-ui/react";

const UserTips = () => {
    return (
        <UserLayout>
            <Box maxW="1000px" mx="auto" px={4}>
                <Box maxW="900px" mx="auto" mt={2}>
                    <Box
                        bgGradient="linear(to-r, #3182ce, #63b3ed)"
                        color="white"
                        py={3}
                        px={6}
                        borderTopRadius="xl"
                        boxShadow="md"
                    >
                        <Heading size="sm">Tips</Heading>
                    </Box>
                    <Box

                        bg="white"
                        p={{ base: 4, md: 6 }}
                        borderWidth={1}
                        borderColor="gray.200"
                        borderBottomRadius="xl"
                        boxShadow="xl"
                    >
                        <OrderedList spacing={3} fontSize="sm" color="gray.700">
                            <ListItem>Go to main roads / roads with higher traffic for more options</ListItem>
                            <ListItem>Wait at landmarks / near bus stops for easy pickup</ListItem>
                            <ListItem>Do not ask for pickup near signals</ListItem>
                            <ListItem>Do not carry luggage</ListItem>
                            <ListItem>If it is a longer journey, you can break the journey into smaller rides</ListItem>
                            <ListItem>Reach faster with multiple rides to your destination</ListItem>
                            <ListItem>Look at driver details and rating before confirming ride</ListItem>
                            <ListItem>Dress decently</ListItem>
                            <ListItem>For pickup, wait at a point which is not crowded/congested and easy for the driver to stop</ListItem>
                            <ListItem>Ensure ride details match with OTP before getting into the car</ListItem>
                            <ListItem>Speak softly in the car</ListItem>
                            <ListItem>Do not smoke or eat in the car</ListItem>
                            <ListItem>Do not act in a way that can disturb others</ListItem>
                            <ListItem>Question driver if route is being deviated</ListItem>
                            <ListItem>Ensure emergency numbers are correct</ListItem>
                            <ListItem>Use emergency button whenever required</ListItem>
                            <ListItem>Get on and get off the car from the left</ListItem>
                            <ListItem>Use AAJAA during normal hours - 8am to 8pm</ListItem>
                        </OrderedList>
                    </Box>
                </Box>
            </Box>
        </UserLayout>
    )
}

export default UserTips
